import React from 'react';
import { CalendarDays, Check } from 'lucide-react';
import { CalendlyEmbed } from './CalendlyEmbed';
import { images } from '../../data/foundingProgram';
const callDetails = ['Professor, Ivey and INSEAD', 'Founder, SikhiWiki', 'The deck, shared live'];
export function MeetFounder() {
  return <section id="booking" className="scroll-mt-20 bg-[#08070A]" data-id="element-1426" data-mp="3t6kyxc4e8e5j">
      <div className="mx-auto w-full max-w-7xl px-5 py-20 sm:px-8" data-id="element-1427" data-mp="12iexr32ja9o">
        <div className="mx-auto max-w-3xl text-center" data-id="element-1428" data-mp="128ndz2dkv1v">
          <p className="text-[10px] font-medium uppercase tracking-[0.32em] text-[#D4AF37]" data-id="element-1429" data-mp="613jg2pcsg3x">
            Your invitation
          </p>
          <h2 className="mt-5 font-serif text-4xl leading-tight text-[#FDFBF7] sm:text-6xl" data-id="element-1430" data-mp="astts8oaj3vc">
            Pick a time. I&rsquo;ll share the vision.
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-lg font-light leading-relaxed text-[#FDFBF7]/65" data-id="element-1431" data-mp="kr180jr737tn">
            Twenty minutes with Ash Singh. See the deck, understand the
            opportunity, decide if your name belongs on it.
          </p>
        </div>

        <div className="mt-12 grid gap-8 lg:grid-cols-[0.34fr_0.66fr] lg:items-start" data-id="element-1432" data-mp="3ccnz8rr1v6lc">
          <aside className="border border-[#D4AF37]/25 bg-[#0B0A0E] p-7 text-center lg:sticky lg:top-24" data-id="element-1433" data-mp="37emjogsu1pem">
            <img src={images.ash} alt="Ash Singh, creator of Sikh Kingdoms" className="mx-auto h-40 w-40 rounded-full border border-[#D4AF37]/35 bg-white object-cover object-top" data-id="element-1434" data-mp="32ixfu19s5mci" />
            <h3 className="mt-6 font-serif text-3xl text-[#FDFBF7]" data-id="element-1435" data-mp="3q5vsenus4a55">Ash Singh</h3>
            <p className="mt-2 text-[10px] uppercase tracking-[0.25em] text-[#D4AF37]" data-id="element-1436" data-mp="3lfp4yrc06voh">
              Creator, Sikh Kingdoms
            </p>
            <div className="mt-7 space-y-3 border-t border-[#D4AF37]/15 pt-6 text-left" data-id="element-1437" data-mp="3gfkk6p42besg">
              {callDetails.map(item => <p key={item} className="flex items-center gap-3 text-sm font-light text-[#FDFBF7]/60" data-id="element-1438" data-mp="hsov55wpb2m5">
                  <Check className="h-3.5 w-3.5 shrink-0 text-[#D4AF37]" aria-hidden="true" data-id="element-1439" data-mp="278sg7fcgv0ib" />
                  {item}
                </p>)}
            </div>
            <p className="mt-7 flex items-center justify-center gap-2 text-xs text-[#FDFBF7]/40" data-id="element-1440" data-mp="1xho2eiyj1lp2">
              <CalendarDays className="h-4 w-4 text-[#D4AF37]" aria-hidden="true" data-id="element-1441" data-mp="22f6eujbr6j1t" />
              Choose any open time
            </p>
          </aside>

          <div className="overflow-hidden border border-[#D4AF37]/25 bg-white" data-id="element-1442" data-mp="1sk621gykseso">
            <CalendlyEmbed data-id="element-1443" data-mp="1ekdefuicieox" />
          </div>
        </div>
      </div>
    </section>;
}